/**
 * Structured Logging Utility
 *
 * Provides consistent logging format across the application.
 * In production, this should integrate with a logging service.
 */

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

interface LogEntry {
  level: LogLevel;
  message: string;
  timestamp: string;
  context?: Record<string, unknown>;
  error?: Error;
}

class Logger {
  private formatEntry(level: LogLevel, message: string, context?: Record<string, unknown>, error?: Error): LogEntry {
    return {
      level,
      message,
      timestamp: new Date().toISOString(),
      ...(context && { context }),
      ...(error && { error: { name: error.name, message: error.message, stack: error.stack } }),
    };
  }

  debug(message: string, context?: Record<string, unknown>): void {
    if (process.env.NODE_ENV === 'development') {
      console.debug(JSON.stringify(this.formatEntry('debug', message, context)));
    }
  }

  info(message: string, context?: Record<string, unknown>): void {
    console.log(JSON.stringify(this.formatEntry('info', message, context)));
  }

  warn(message: string, context?: Record<string, unknown>): void {
    console.warn(JSON.stringify(this.formatEntry('warn', message, context)));
  }

  error(message: string, error?: Error, context?: Record<string, unknown>): void {
    console.error(JSON.stringify(this.formatEntry('error', message, context, error)));
  }
}

export const logger = new Logger();

